






import Vue from 'vue'
import Student from '@/models/Students/Student'
import msgrsList from '@/components/Students/msgrsList.vue'

export default Vue.extend({
  name: 'studColMsgrList',
  props: {
    row: Object as () => Student,
  },
  components: {
    msgrsList
  }
})
